import React from 'react';
import { Twitter, Linkedin, Github } from 'lucide-react';

const HEADING = { fontFamily: "'Space Grotesk', system-ui, sans-serif" } as const;

const FOOTER_LINKS = {
  Produit: [
    { label: 'Vue produit', href: '/product' },
    { label: 'Solutions', href: '/solutions' },
    { label: 'Tarifs', href: '/pricing' },
    { label: 'Sécurité', href: '/security' },
  ],
  Ressources: [
    { label: 'Centre de ressources', href: '/resources' },
    { label: 'Guide IT & Réseau', href: '/it-guide' },
    { label: 'Clients', href: '/customers' },
    { label: 'Blog', href: '/resources#blog' },
  ],
  Entreprise: [
    { label: 'À propos', href: '/about' },
    { label: 'Contact', href: '/contact' },
    { label: 'Carrières', href: '/about#careers' },
    { label: 'Presse', href: '/about#press' },
  ],
  Légal: [
    { label: 'Confidentialité', href: '/privacy' },
    { label: 'CGU', href: '/terms' },
    { label: 'Cookies', href: '/privacy#cookies' },
    { label: 'Mentions légales', href: '/about#legal' },
  ],
};

export function MarketingFooter() {
  return (
    <footer className="bg-[#0a0a1a] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <a href="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 bg-[#4f46e5] rounded-xl flex items-center justify-center shadow-[0_0_24px_rgba(79,70,229,0.4)]">
                <div className="w-4 h-4 border-2 border-white rotate-45" />
              </div>
              <span className="text-lg font-bold text-white" style={HEADING}>Lapyno</span>
            </a>
            <p className="text-sm text-slate-400 mb-4">
              La gestion de projet moderne pour les équipes qui veulent avancer.
            </p>
            <div className="flex gap-3">
              {[Twitter, Linkedin, Github].map((Icon, i) => (
                <a key={i} href="#" className="p-2 rounded-lg bg-[#141432] border border-white/5 text-slate-400 hover:text-white hover:border-[#4f46e5]/40 transition-colors">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(FOOTER_LINKS).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-bold text-white mb-4 text-sm" style={HEADING}>{title}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <a 
                      href={link.href}
                      className="text-sm text-slate-400 hover:text-white transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} Lapyno. Tous droits réservés.
          </p>
          <p className="text-sm text-slate-500">
            Fait avec ❤️ en France
          </p>
        </div>
      </div>
    </footer>
  );
}
